import { render } from "./LaborTable.vue?vue&type=template&id=1c7cb932&scoped=true"
import script from "./LaborTable.vue?vue&type=script&lang=js"
export * from "./LaborTable.vue?vue&type=script&lang=js"

import "./LaborTable.vue?vue&type=style&index=0&id=1c7cb932&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7cb932"]])

export default __exports__